<ng-container *ngIf="address">
  <div class="row no-gutters px-3 py-3 my-3 mb-address-tile"
       data-cy="mb-address-tile"
       (click)="onAddressSelected($event)"
       [ngClass]="[isSelectedAddress ? 'selected' : '', showSelectionRadiobox ? 'mb-address-tile-cursor' : '',(supportingAccountCreation$ | async) && !(supportingGuestCheckout$ | async) && (address.verificationStatus === constants.ADDRESS_VERIFIED_REJECTED_STATUS_04) ? 'disable-tile' : '']">
    <div class="col-12 mb-checkout-address-tile-wrapper">
      <input type="radio"  *ngIf="showSelectionRadiobox"
             [id]="address?.id"
             name="address-tile"
             [checked]="isSelectedAddress"
             data-cy="mb-address-tile-input"
             [disabled]="(supportingAccountCreation$ | async) && !(supportingGuestCheckout$ | async) && address.verificationStatus === constants.ADDRESS_VERIFIED_REJECTED_STATUS_04"
            />
      <label class="mb-address-tile-content mb-custom-label" [for]="address?.id">
        <div [ngClass]="{'mb-address-tile-radio-space': showSelectionRadiobox}">
          <div *ngIf="address?.companyName">{{address?.companyName}}</div>
          <div *ngIf="address?.institute">{{address?.institute}}</div>
          <div *ngIf="address?.department">{{address?.department}}</div>
          <div *ngIf="address?.lab">{{address?.lab}}</div>
          <div *ngIf="address?.building">{{address?.building}}</div>
          <div *ngIf="address?.streetInformation">{{address?.streetInformation}}</div>

          <ng-container *ngIf="formRegion === checkoutRegions?.EU">
            <div *ngIf="address?.postalCode || address?.town"> {{address?.postalCode}} {{address?.town}}</div>
          </ng-container>

        <ng-container *ngIf="formRegion === checkoutRegions?.US || formRegion === checkoutRegions?.AU">
          <div *ngIf="address?.town || address?.postalCode || address?.region">{{address?.town}} {{address?.region?.name}}, {{address?.postalCode}}</div>
        </ng-container>

          <div *ngIf="address?.country">{{address?.country?.name}}</div>
          <div class="mt-2"
               *ngIf="hasSalesTaxExemption"
               data-cy="mb-address-sales-exemption">
            {{ 'address.salesTaxExemption' | mbTranslate }} {{ (address?.taxExempt ? 'mbcommon.yes' : 'mbcommon.no') | mbTranslate}}
          </div>
        </div>
      </label>
    </div>

    <ng-container *ngIf="(supportingAccountCreation$ | async) && !(supportingGuestCheckout$ | async)">
      <div class="col-12 mt-3 align-self-end mb-address-status">
        <ng-container [ngSwitch]="address.verificationStatus">
          <ng-container *ngSwitchCase="constants.ADDRESS_VERIFIED_APPROVED_STATUS_03">
            <img src="assets/icons/svg/circle-check-solid.svg"
                 class="mb-address-status-icon"
                 alt="Address verified"
                 title="Address verified"
                 aria-label="Address verified"
                 data-cy="mb-address-status-icon">
            <span class="pl-1 mb-address-status-text">{{ 'address.status.verified' | mbTranslate }}</span>
          </ng-container>

          <ng-container *ngSwitchCase="constants.ADDRESS_VERIFIED_REJECTED_STATUS_04">
            <img src="assets/icons/svg/circle-xmark-solid.svg"
                 class="mb-address-status-icon"
                 alt="Address verified"
                 title="Address verified"
                 aria-label="Address verified"
                 data-cy="mb-address-status-icon">
            <span class="pl-1 mb-address-status-text">{{ 'address.status.rejected' | mbTranslate }}</span>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <img src="assets/icons/svg/clock-solid.svg"
                 class="mb-address-status-icon"
                 alt="Address verified"
                 title="Address verified"
                 aria-label="Address verified"
                 data-cy="mb-address-status-icon">
            <span class="pl-1 mb-address-status-text">{{ 'address.status.inVerification' | mbTranslate }}</span>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

  </div>
</ng-container>
